import queryString from 'query-string';
import { apiFetch } from './utils/api';

// eslint-disable-next-line no-unused-vars
const mockedSecurities = require('./mocks/v2/qlik/portfolio-lenses.json');

export const securities = {
  get: async (args) => {
    // return mockedSecurities;
    const options = {
      method: 'GET',
    };

    const query = queryString.stringify(args, { arrayFormat: 'comma' });
    const url = `v2/qlik/portfolio-lenses?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
